import { render, staticRenderFns } from "./SignWithEmail.vue?vue&type=template&id=fd7ae338&scoped=true&"
import script from "./SignWithEmail.vue?vue&type=script&lang=js&"
export * from "./SignWithEmail.vue?vue&type=script&lang=js&"
import style0 from "./SignWithEmail.vue?vue&type=style&index=0&id=fd7ae338&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7ae338",
  null
  
)

export default component.exports